import { CodeSystem } from 'context/elasticsearch/types'

const clinicalCodesystems = [
	CodeSystem.Icd10,
	CodeSystem.Icpc2,
	CodeSystem.Nkpk,
	CodeSystem.Phbu,
]

const isClinicalCodesystem = (codeSystem: CodeSystem) => {
	return clinicalCodesystems.some((codesystem) => codesystem === codeSystem)
}

export default isClinicalCodesystem
